import { createContext, useContext, type ReactNode } from 'react'
import * as api from './api'

const ApiContext = createContext(api)

export function ApiProvider({ children }: { children: ReactNode }) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>
}

export function useApi() {
  return useContext(ApiContext)
}
